import PersonPinCircleIcon from '@material-ui/icons/PersonPinCircle';
export const ContactpointIcon = PersonPinCircleIcon;

